import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { LogoComponent } from "../logo/logo.component";
import { CustomAvatarComponent } from "../custom-avatar/custom-avatar.component";
import { CommonModule } from '@angular/common';
import { MobileDrawerComponent } from "../mobile-drawer/mobile-drawer.component";
import { UserInitialsService } from '../../../core/services/user-initials.service';
import { UserDataService } from '../../../core/services/user-data.service';
import { ProfileImageService } from '../../../core/services/profile-image.service';
import { Router } from '@angular/router';
import { NotificationsPopupComponent } from "../notifications-popup/notifications-popup.component";
import { NotificationService } from '../../../core/services/notification.service';
import { Notification } from '../../../core/interfaces/notifications-interface';

@Component({
  selector: 'app-mobile-topbar',
  standalone: true,
  imports: [LogoComponent, CustomAvatarComponent, CommonModule, MobileDrawerComponent, NotificationsPopupComponent],
  templateUrl: './mobile-topbar.component.html',
  styleUrl: './mobile-topbar.component.css'
})
export class MobileTopbarComponent implements OnInit {
  constructor(private userInitialsService: UserInitialsService, private userData: UserDataService, private profileImage: ProfileImageService, private router: Router, private notificationService: NotificationService) { }

  @Input() selectedItemId: number = 0;

  // User initials or image
  get userInitials(): string {
    return this.userInitialsService.getUserInitials(this.userData.getUser()?.first_name ?? '', this.userData.getUser()?.last_name ?? '');
  }

  get getProfileImage(): string | null {
    return this.profileImage.getProfileImage();
  }

  // Notifications
  showPopup = false;

  get notifications(): Notification[] {
    return this.notificationService.getListOfNotifications();
  }

  get unreadCount(): number {
    return this.notificationService.getUnreadNotificationsCount();
  }

  get waitingForNextPage(): boolean {
    return this.notificationService.getWaitingForNextPage();
  }

  @ViewChild('popupContainer', { static: true }) popupRef!: ElementRef;

  ngOnInit(): void {
    this.notificationService.connect();
  }

  openDashboard() {
    this.router.navigate(['/dashboard']);
  }

  togglePopup() {
    if (!this.showPopup && this.notifications.length <= 0) {
      return;
    }

    this.showPopup = !this.showPopup;
  }

  markAsRead(id: string) {
    const notification = this.notifications.find(n => n.id === id);
    if (notification && !notification.is_read) {
      notification.is_read = true;

      this.notificationService.sendSetAsRead(notification.id, true)
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.popupRef && !this.popupRef.nativeElement.contains(event.target)) {
      this.showPopup = false;
    }
  }

  loadMoreCallback = () => {
    this.notificationService.requestNewPage();
  };
}
